import { render, staticRenderFns } from "./GroupDetailMember.vue?vue&type=template&id=564402b4&scoped=true"
import script from "./GroupDetailMember.vue?vue&type=script&lang=js"
export * from "./GroupDetailMember.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailMember.vue?vue&type=style&index=0&id=564402b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564402b4",
  null
  
)

export default component.exports